import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { DepartureTypeActions, DepartureTypeActionTypes } from './departure-type.actions';
import { DepartureTypeNgrx } from './departure-type.model';

export interface DepartureTypes extends EntityState<DepartureTypeNgrx> {
  // additional entities state properties
}

export const adapter: EntityAdapter<DepartureTypeNgrx> = createEntityAdapter<DepartureTypeNgrx>({
  selectId: (e) => e.type,
});

export const initialState: DepartureTypes = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): DepartureTypes {
  const action: DepartureTypeActions = incomingAction as DepartureTypeActions;
  switch (action.type) {
    case DepartureTypeActionTypes.AddDepartureType: {
      return adapter.addOne(action.payload.departureType, state);
    }

    case DepartureTypeActionTypes.UpsertDepartureType: {
      return adapter.upsertOne(action.payload.departureType, state);
    }

    case DepartureTypeActionTypes.AddDepartureTypes: {
      return adapter.addMany(action.payload.departureTypes, state);
    }

    case DepartureTypeActionTypes.UpsertDepartureTypes: {
      return adapter.upsertMany(action.payload.departureTypes, state);
    }

    case DepartureTypeActionTypes.UpdateDepartureType: {
      return adapter.updateOne(action.payload.departureType, state);
    }

    case DepartureTypeActionTypes.UpdateDepartureTypes: {
      return adapter.updateMany(action.payload.departureTypes, state);
    }

    case DepartureTypeActionTypes.DeleteDepartureType: {
      return adapter.removeOne(action.payload.id, state);
    }

    case DepartureTypeActionTypes.DeleteDepartureTypes: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DepartureTypeActionTypes.LoadDepartureTypes: {
      return adapter.setAll(action.payload.departureTypes, state);
    }

    case DepartureTypeActionTypes.ClearDepartureTypes: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
